import API from "../../../lib/API";

export const settingsTermService = {
  getTerms: async () => {
    try {
      const response = await API.get("/settings-terms");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createTerm: async (data) => {
    try {
      const response = await API.post("/settings-terms", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateTerm: async (id, data) => {
    try {
      const response = await API.put(`/settings-terms/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteTerm: async (id) => {
    try {
      const response = await API.delete(`/settings-terms/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
